export default __webpack_public_path__ + "static/media/Virtual2.6307d03c.webp";